import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ModalLayout from "./modallayout";
import { CreateAuthSlice } from "../../redux/slices/createUser";
import {
  ablyClient,
  ResetPasswordChannel,
  sendAblyMessage,
} from "../../lib/socket";
import { CraditSlice } from "../../redux/slices/cradit";
import { getGData } from "../../redux/slices/ggame";
import { RedeemSlice } from "../../redux/slices/radeem";
import { toast } from "react-toastify";
import { ResetSlice } from "../../redux/slices/resetpass";

export function CraditBal({ isOpen, onCancel, game }) {
  const [selectedAmount, setSelectedAmount] = useState(null);
  const [amount, setAmount] = useState(0);
  const [error, setError] = useState("");
  const { user } = useSelector((val) => val?.login);
  const dispatch = useDispatch();

  useEffect(() => {
    if (isOpen) {
      setAmount(0);
      setSelectedAmount(null);
      setError("");
    }
  }, [isOpen]);

  useEffect(() => {
    const channel = ablyClient.channels.get("admin-credit");

    const messageHandler = (message) => {
      const { senderId, receiverId, text } = message.data;

      // if (senderId === userid) {
      dispatch(getGData());
      // }
    };

    channel.subscribe("private-credit", messageHandler);

    return () => {
      channel.unsubscribe("private-credit", messageHandler);
    };
  }, [dispatch]);

  const handleAmountClick = (value) => {
    setAmount(value);
    setSelectedAmount(value);
    setError("");
  };

  const balance = useSelector((value) => value?.games?.data?.balance);

  const handleConfirm = async () => {
    if (amount <= 0) {
      setError("Amount should be greater than zero");
      return;
    }
    if (parseInt(amount) > parseInt(balance)) {
      setError("Insufficient balance to add credit");
      return;
    }
    const data = Object.assign({ ...game }, { amount: amount });
    const res = await dispatch(CraditSlice(data));
    if (res) {
      // await addCreditChannel(
      //   "admin-credit",
      //   user.id,
      //   "admin-456",
      //   "private-credit"
      // );
      setSelectedAmount(null);
      setAmount(0);
      onCancel();
    }
    return null;
  };

  return (
    <ModalLayout
      isOpen={isOpen}
      onConfirm={handleConfirm}
      onCancel={onCancel}
      title="Add Credit"
    >
      <div className="container text-center">
        {/* Balance Section */}
        <div className="row justify-content-center mb-4">
          <div className="col-12 col-sm-6 col-md-5 p-2">
            <div className="text-center p-3">
              <p className="fw-bold mb-1" style={{ fontSize: "14px" }}>
                Balance
              </p>
              <p className="fw-bold mb-0" style={{ fontSize: "20px" }}>
                ${balance ? balance : 0}
              </p>
            </div>
          </div>
          <div className="col-12 col-sm-6 col-md-5 p-2">
            <div className="text-center p-3">
              <p className="fw-bold mb-1" style={{ fontSize: "14px" }}>
                In-game
              </p>
              <p className="fw-bold mb-0" style={{ fontSize: "20px" }}>
                ${game?.gamebalance ? game?.gamebalance : 0}
              </p>
            </div>
          </div>
        </div>

        {/* Amount Selection */}
        <p className="p-2 text-start fw-bold" style={{ fontSize: "16px" }}>
          Amount to be added
        </p>
        <div className="d-flex justify-content-center flex-wrap gap-2 mb-3">
          {[100, 50, 30, 10, 5].map((value) => (
            <button
              key={value}
              className={`btn btn-outline-warning ${
                selectedAmount === value ? "active-btn active-btn-color" : ""
              }`}
              onClick={() => handleAmountClick(value)}
            >
              ${value}
            </button>
          ))}
        </div>

        {/* Amount Input */}
        <div className="d-flex align-items-center mb-4 w-100">
          <label
            htmlFor="amount"
            className="fw-bold me-2"
            style={{ fontSize: "16px" }}
          >
            Amount
          </label>
          <input
            type="text"
            id="amount"
            className="form-control text-center bg--base"
            value={amount}
            required
            style={{
              maxWidth: "100px",
              fontWeight: "bold",
              border: "1px solid #ccc",
              padding: "5px 10px",
            }}
            onChange={(e) => {
              const inputValue = Number(e.target.value);
              setAmount(e.target.value);
              setSelectedAmount(
                [100, 50, 30, 10, 5].includes(inputValue) ? inputValue : null
              );
              setError("");
            }}
          />
        </div>
        {error && <p className="text-danger fw-bold mt-1">{error}</p>}
      </div>
    </ModalLayout>
  );
}

export function AddGameModel({ isOpen, onCancel }) {
  const { user } = useSelector((val) => val.login);
  const dispatch = useDispatch();
  const { data } = useSelector((g) => g.games);

  const [selectedGame, setSelectedGame] = useState(null);

  const handleGameClick = (game) => {
    setSelectedGame(game);
  };

  const handleConfirm = async () => {
    const object = {
      name: user.name,
      uid: user.id,
      username: selectedGame.username,
      gameid: selectedGame._id,
      slug: selectedGame.slug,
    };
    await dispatch(CreateAuthSlice(object));
    await sendAblyMessage("admin-chennal", user.id, "admin-456", "private");
    return null;
  };

  return (
    <ModalLayout
      isOpen={isOpen}
      onConfirm={handleConfirm}
      onCancel={onCancel}
      title="Add Game"
    >
      {" "}
      <div
        className="d-flex flex-wrap justify-content-center gap-4"
        style={{
          maxHeight: "400px", // Adjust the height as needed
          overflowY: "scroll", // Enables vertical scrolling if content overflows
        }}
      >
        {data?.remainggames?.length > 0 &&
          data?.remainggames.map((game, index) => {
            return (
              <div
                key={index}
                className="card py-2"
                style={{
                  width: "200px",
                  border:
                    selectedGame?._id === game._id
                      ? "3px solid #c246a5"
                      : "1px solid #ccc",
                  cursor: "pointer",
                }}
                onClick={() => handleGameClick(game)}
              >
                <img
                  src={`${process.env.REACT_APP_APIURL}${game.logo}`}
                  alt={game.name}
                  className="card-img-top mb-2"
                  style={{ objectFit: "contain", height: "100px" }}
                />
                <div className="text-center">
                  <h5 className="card-title m-0" style={{ fontSize: "18px" }}>
                    {game.name}
                  </h5>
                </div>
              </div>
            );
          })}
      </div>
    </ModalLayout>
  );
}

export function RadeemAccount({ isOpen, onCancel, game }) {
  const [selectedAmount, setSelectedAmount] = useState(null);
  const [amount, setAmount] = useState(0);
  const [error, setError] = useState("");
  const dispatch = useDispatch();
  const { user } = useSelector((val) => val?.login);

  useEffect(() => {
    if (isOpen) {
      setAmount(0);
      setSelectedAmount(null);
      setError("");
    }
  }, [isOpen]);

  useEffect(() => {
    const channel = ablyClient.channels.get("admin-redeem");
    const userid = user?.id;

    const messageHandler = (message) => {
      const { senderId, receiverId, text } = message.data;
      dispatch(getGData());
    };

    channel.subscribe("private-redeem", messageHandler);

    return () => {
      channel.unsubscribe("private-redeem", messageHandler);
    };
  }, [dispatch]);

  const handleAmountClick = (value) => {
    setAmount(value);
    setSelectedAmount(value);
    setError("");
  };

  const handleConfirm = async () => {
    if (!amount) {
      setError("Amount is required for redeem.");
      return;
    }
    if (parseInt(amount) < parseInt(50)) {
      setError("Min. $50 required to proceed with redeem.");
      return;
    }
    const data = Object.assign({ ...game }, { amount: amount });
    const res = await dispatch(RedeemSlice(data));
    if (res) {
      // await RedeemChannel(
      //   "admin-redeem",
      //   userId,
      //   "admin-456",
      //   "private-redeem"
      // );
      setSelectedAmount(null);
      setAmount(0);
      onCancel();
    }
    return null;
  };

  const balance = useSelector((value) => value?.games?.data?.balance);
  return (
    <ModalLayout
      isOpen={isOpen}
      onConfirm={handleConfirm}
      onCancel={onCancel}
      title="Redeem Amount"
    >
      <div className="text-center">
        {/* In-game and Balance Section */}
        <div className="d-flex flex-column flex-md-row justify-content-between gap-2 mb-4">
          <div className="text-center p-3 bg-light rounded w-100 w-md-50">
            <p className="fw-bold mb-1">In-game</p>
            <p className="fw-bold fs-5 mb-0">
              ${game?.gamebalance ? game?.gamebalance : 0}
            </p>
          </div>
          {game?.wins > 0 && (
            <div className="text-center p-3 bg-light rounded w-100 w-md-50">
              <p className="fw-bold mb-1">Win Balance</p>
              <p className="fw-bold fs-5 mb-0">
                ${game?.wins ? game?.wins : 0}
              </p>
            </div>
          )}

          <div className="text-center p-3 bg-light rounded w-100 w-md-50">
            <p className="fw-bold mb-1">Balance</p>
            <p className="fw-bold fs-5 mb-0">
              ${parseInt(balance) ? parseInt(balance) : 0}
            </p>
          </div>
        </div>

        {/* Amount Selection */}
        <p className="p-2 fw-bold text-start">Amount to be cashed out</p>
        <div className="d-flex flex-wrap justify-content-center gap-2 mb-3">
          {[100, 50, 30, 10, 5].map((value) => (
            <button
              key={value}
              className={`btn btn-outline-warning ${
                selectedAmount === value ? "!active-btn active-btn-color" : ""
              }`}
              onClick={() => handleAmountClick(value)}
            >
              ${value}
            </button>
          ))}
          {/* <button className="btn btn-outline-danger" onClick={handleReset}>
          RESET
        </button> */}
        </div>

        {/* Amount Input */}
        <div className="d-flex align-items-center  w-100 w-md-50 mx-auto p-2 ">
          <label htmlFor="amount" className="fw-bold me-2">
            Amount
          </label>
          <input
            type="text"
            id="amount"
            className="form-control text-center bg--base"
            value={amount}
            required
            style={{
              maxWidth: "100px",
              fontWeight: "bold",
              border: "1px solid #ccc",
              padding: "5px 10px",
            }}
            onChange={(e) => {
              const inputValue = Number(e.target.value);
              setAmount(e.target.value);
              setSelectedAmount(
                [100, 50, 30, 10, 5].includes(inputValue) ? inputValue : null
              );
              setError("");
            }}
          />
        </div>
        {error && <p className="text-danger fw-bold mt-1">{error}</p>}
      </div>
    </ModalLayout>
  );
}

export function ResetPass({ game, isOpen, onCancel }) {
  const [password, setPassword] = useState("");
  const dispatch = useDispatch();
  const { user } = useSelector((val) => val?.login);

  useEffect(() => {
    const channel = ablyClient.channels.get("admin-reset");
    const userid = user?.id;

    const messageHandler = (message) => {
      const { senderId, receiverId, text } = message.data;

      // if (senderId === userid) {
      // dispatch(getGData());
      // }
    };

    channel.subscribe("private-reset", messageHandler);

    return () => {
      channel.unsubscribe("private-reset", messageHandler);
    };
  }, [dispatch]);

  const validatePassword = (password, type) => {
    if (!password || password.length < 6) {
      toast.error("Password must be at least 6 characters long.");
      return false;
    }

    switch (type) {
      case "alphaNumeric":
        if (
          !/^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[\W_]).{6,}$/.test(password)
        ) {
          toast.error(
            "Password must include uppercase, lowercase, digit & special character."
          );
          return false;
        }
        break;
      case "numericOnly":
        if (!/^\d+$/.test(password)) {
          toast.error("Password must contain digits only.");
          return false;
        }
        break;
      default:
        return true;
    }

    return true;
  };

  const handleConfirm = async () => {
    const newData = { ...game, newpassword: password };

    // Determine password rules based on game ID
    let passwordType = "default";
    if (game?.gameid === "67866b36e8a5ed5e5bdf59ef")
      passwordType = "alphaNumeric";
    else if (game?.gameid === "67866b36e8a5ed5e5bdf59f1")
      passwordType = "numericOnly";

    // Validate password
    const isValid = validatePassword(password, passwordType);
    if (!isValid) return;

    try {
      await dispatch(ResetSlice(newData));

      // Notify other clients if required
      if (passwordType !== "alphaNumeric") {
        await ResetPasswordChannel(
          "admin-reset",
          user?.id,
          "admin-456",
          "private-reset"
        );
      }

      onCancel();
      setPassword("");
    } catch (error) {
      toast.error("Failed to reset password. Please try again.");
    }
  };

  const handleCancel = () => {
    setPassword("");
    onCancel();
  };

  return (
    <ModalLayout
      isOpen={isOpen}
      title="Reset Password"
      onConfirm={handleConfirm}
      onCancel={handleCancel}
    >
      <div className="flex flex-col items-center justify-center w-full h-full px-4 py-6">
        <input
          type="text"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="form-control shadow-md w-full sm:w-3/4 lg:w-1/2 p-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#921863]"
          placeholder="Enter your Game Password"
          style={{
            background: "#ff0491ab",
            color: "#fff",
          }}
        />
      </div>
    </ModalLayout>
  );
}
